import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import LeadList from "./list";

import {getAllLeadsListing,getLeadFilters,updateLeadStatus,updateLeadAccount,createNewLead} from "../../../service/LeadManagement/action";

const mapStateToProps = (state) => ({
    allLeads:state.LeadManagement.allLeads,
    leadFilters:state.LeadManagement.leadFilters,
    updatedLead:state.LeadManagement.updatedLead, 
    leadAccount:state.LeadManagement.leadAccount,
    newLead:state.LeadManagement.newLead,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getAllLeadsListing,
            getLeadFilters,
            updateLeadStatus,
            updateLeadAccount,
            createNewLead
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(LeadList);
